import React from 'react';
import { Card, CardContent, Typography, Divider, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Box, Chip } from '@mui/material';
import GroupIcon from '@mui/icons-material/Group';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';

const FamilyMembers = ({ familiares }) => {
  if (!familiares || familiares.length === 0) return null;

  return (
    <Card sx={{ mb: 3, boxShadow: 3 }}>
      <CardContent>
        <Typography variant="h6" gutterBottom sx={{ display: 'flex', alignItems: 'center' }}>
          <GroupIcon sx={{ mr: 1 }} />
          Grupo Familiar
        </Typography>
        <Divider sx={{ mb: 2 }} />
        
        <TableContainer component={Paper} variant="outlined">
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>DNI</TableCell>
                <TableCell>Nombre</TableCell>
                <TableCell>Relación</TableCell>
                <TableCell>Edad</TableCell>
                <TableCell>F. Afiliación</TableCell>
                <TableCell>F. Vigencia</TableCell>
                <TableCell>Estado</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {familiares.map((familiar, index) => (
                <TableRow key={index}>
                  <TableCell>{familiar.id_documento}</TableCell>
                  <TableCell>
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                      {familiar.nombre}
                      {familiar.id_estado === 1 && (
                        <Chip 
                          label={familiar.plan} 
                          size="small" 
                          color="primary" 
                          sx={{ ml: 1, height: 20, fontSize: '0.7rem' }} 
                        />
                      )}
                    </Box>
                  </TableCell>
                  <TableCell>{familiar.relacion || 'No especificado'}</TableCell>
                  <TableCell>{familiar.edad || 'N/A'}</TableCell>
                  <TableCell>{familiar.fecha_afiliacion || 'No especificada'}</TableCell>
                  <TableCell>{familiar.fecvigencia || 'No especificada'}</TableCell>
                  <TableCell>
                    <Box sx={{ 
                      display: 'flex', 
                      alignItems: 'center',
                      color: familiar.estado === 'A' ? 'success.main' : 'error.main',
                      fontWeight: 'bold'
                    }}>
                      {familiar.estado === 'A' ? (
                        <CheckCircleIcon fontSize="small" sx={{ mr: 0.5 }} />
                      ) : (
                        <CancelIcon fontSize="small" sx={{ mr: 0.5 }} />
                      )}
                      <Typography variant="body2">
                        {familiar.estado === 'A' ? 'ACTIVO' : 'DE BAJA'}
                      </Typography>
                    </Box>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </CardContent>
    </Card>
  );
};

export default FamilyMembers;
